export const OK = 200;
export const NO_CONTENT = 204;
export const BAD_REQUEST = 400;
export const NOT_FOUND = 404;
export const TOO_MANY_REQUESTS = 429;
export const INTERNAL_SERVER_ERROR = 500;
export const ERROR_MESSAGE_INVALID_EMAIL = 'Email address is not valid';
export const ERROR_MESSAGE_INVALID_MESSAGE = 'Message is too short';
export const ERROR_MESSAGE_EMAIL_NOT_SENT = 'Email was not sent. Please try again later';
export const ONE_DAY_IN_SECONDS = 86400;
